import { render } from "./StatsLine.vue?vue&type=template&id=65ce3b86&ts=true"
import script from "./StatsLine.vue?vue&type=script&lang=ts"
export * from "./StatsLine.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__